// 박스번호 라벨(80×60mm) 글자 크기 — BoxAssignModal / logisaddimportV0 手动打印 공용.
// 라벨 아래 18mm 는 바코드 자리로 고정하고, 글자는 남은 자리(폭 76mm × 높이 약 36mm)에 들어가도록
// 가장 긴 줄 길이로 크기를 줄인다. 짧은 이름은 최대 40px 그대로.
const MAX_PX = 40;
const WIDTH_PX = 280; // 76mm(=287px) 에서 약간 여유
const HEIGHT_PX = 132; // 60mm - 여백 4mm - 바코드 18mm - 간격 2mm ≈ 36mm(=136px)
const LINE_HEIGHT = 1.1;

// 굵은 글꼴 기준 글자 폭(글자 크기 대비) 어림값. 넉넉하게 잡아 줄바꿈이 안 생기게 한다.
function charUnits(ch) {
  if (/[\u1100-\u11ff\u3000-\u9fff\uac00-\ud7af\uff00-\uffef]/.test(ch)) return 1.0; // 한글·한자·전각
  if (/[A-Z0-9]/.test(ch)) return 0.72;
  return 0.6;
}

export function boxLabelFontSize(label) {
  const lines = String(label || '').split('\n');
  const widest = Math.max(1, ...lines.map(l => Array.from(l).reduce((s, ch) => s + charUnits(ch), 0)));
  const byWidth = WIDTH_PX / widest;
  const byHeight = HEIGHT_PX / (lines.length * LINE_HEIGHT);
  return Math.floor(Math.min(MAX_PX, byWidth, byHeight));
}
